// extracted by mini-css-extract-plugin
module.exports = {"boxImage":"image_boxImage__1Dmpw","img":"image_img__2ZRUe","brokenPicture":"image_brokenPicture__WP65z"};